import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-business-release-notes',
    templateUrl: './business-release-notes.component.html',
    styleUrls: ['./business-release-notes.component.scss'],
    standalone: false
})
export class BusinessReleaseNotesComponent implements OnInit {
  businessNotes: ReleaseNotesDocuments[] = [];
  selectedDocument;
  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.http
      .get(environment.businessReleaseNotesConfigUrl)
      .subscribe((resp: ReleaseNotesDocuments[]) => {
        if (resp) {
          this.businessNotes = resp;
          console.log(this.businessNotes);
          this.eachDocument(this.businessNotes[0]);
        }
      });
  }

  eachDocument(note) {
    this.selectedDocument = note;
  }
}

export class ReleaseNotesDocuments {
  url: string;
  type: string;
  title: string;
}
